'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface StudentVerificationBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  schoolName?: string;
  className?: string;
}

export default function StudentVerificationBadge({
  size = 'md',
  showLabel = true,
  schoolName,
  className = '',
}: StudentVerificationBadgeProps) {
  const sizeConfig = {
    sm: { icon: 12, text: 'text-[10px]', px: 'px-1.5 py-0.5', gap: 'gap-1' },
    md: { icon: 14, text: 'text-xs', px: 'px-2 py-1', gap: 'gap-1.5' },
    lg: { icon: 16, text: 'text-sm', px: 'px-3 py-1.5', gap: 'gap-2' },
  };

  const cfg = sizeConfig[size];

  return (
    <span
      className={`inline-flex items-center ${cfg.gap} ${cfg.px} bg-violet-100 text-violet-700 border border-violet-200 rounded-full font-600 ${cfg.text} ${className}`}
      title={schoolName ? `Verified Student — ${schoolName}` : 'Verified Student Traveler'}
    >
      <Icon name="AcademicCapIcon" size={cfg.icon} className="text-violet-600 flex-shrink-0" />
      {showLabel && (
        <span className="whitespace-nowrap">
          {schoolName ? `Student · ${schoolName}` : 'Verified Student'}
        </span>
      )}
    </span>
  );
}
